export enum enumDropdownActionIconColor {
  DEFAULT = 'default',
  WHITE = 'white',
  CURRENT = 'currentColor',
  LIGHT_GRAY = 'light-gray',
}
